import React, { FC } from 'react';

import { StyledFileIcon } from '../FileItem/styled';
import { StyledText, StyledWrapper } from './styled';

interface IconDocumentProps {
  name: string;
}

const IconDocument: FC<IconDocumentProps> = ({ name }) => (
  <StyledWrapper>
    <StyledFileIcon />
    <StyledText>{name}</StyledText>
  </StyledWrapper>
);

export default IconDocument;
